// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Application_pageContent__2IEH8","tabsContainer":"Application_tabsContainer__O1hVI"};